"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Typography_1 = __importDefault(require("../Typography"));
var ColorBox_1 = __importDefault(require("./ColorBox"));
var generateClientColors_1 = __importDefault(require("./generateClientColors"));
var colors_1 = require("./colors");
var styles_1 = require("./styles");
var ClientColorsComponent = function () {
    var _a = __read((0, react_1.useState)(colors_1.tannerPurple['500']), 2), hexCode = _a[0], setHexCode = _a[1];
    var _b = __read((0, react_1.useState)((0, generateClientColors_1.default)(hexCode)), 2), clientColors = _b[0], setClientColors = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), error = _c[0], setError = _c[1];
    var handleAddColor = function (event) {
        var _a;
        if ((event === null || event === void 0 ? void 0 : event.key) === 'Enter') {
            if (!((_a = /^#[0-9A-F]{6}$/i) === null || _a === void 0 ? void 0 : _a.test(hexCode))) {
                setError('# is required with the hex code (ex. #7942DD)');
                setClientColors([]);
            }
            else {
                var newClientColors = hexCode ? (0, generateClientColors_1.default)(hexCode) : [];
                setClientColors(newClientColors);
                setError('');
            }
        }
    };
    return (react_1.default.createElement(styles_1.RootBox, null,
        react_1.default.createElement(styles_1.TitleTypography, { variant: "h3" }, "Client Color"),
        react_1.default.createElement(Typography_1.default, null,
            "This color represents our client color. In Figma designs, this color is represented as",
            react_1.default.createElement(styles_1.ClientColorTitleTypography, { style: { paddingLeft: '4px' } }, "Purple"),
            ". In the live product, this color comes from the clients hex code that is entered in the Themes space of Admin."),
        react_1.default.createElement(styles_1.StyledTextField, { id: "filled-basic", label: "Client Color Example", size: "medium", value: hexCode, onChange: function (e) {
                var _a;
                setHexCode((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
                setError('');
            }, onKeyPress: handleAddColor, error: !!error, helperText: error }),
        !error && (react_1.default.createElement(styles_1.GridBox, null, clientColors === null || clientColors === void 0 ? void 0 : clientColors.map(function (_a) {
            var color = _a.color, label = _a.label;
            return (react_1.default.createElement(ColorBox_1.default, { key: color, color: color, label: label }));
        })))));
};
exports.default = ClientColorsComponent;
//# sourceMappingURL=ClientColorsComponent.js.map